module.exports = __webpack_public_path__ + "img/candy-crush.png";